import { z } from 'zod';
import { RECURRING_INTERVALS } from '../types/recurringSchedule';

const isoDate = () => z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD');

export const recurringIntervalSchema = z.enum(RECURRING_INTERVALS);

export const recurringJobScheduleInputSchema = z.object({
  sourceJobId: z.string().uuid(),
  interval: recurringIntervalSchema,
  startDate: isoDate(),
});

export const recurringJobScheduleUpdateSchema = z.object({
  interval: recurringIntervalSchema.optional(),
  startDate: isoDate().optional(),
}).refine((data) => data.interval !== undefined || data.startDate !== undefined, {
  message: 'At least one of interval or startDate must be provided',
});
